import { Component }   from '@angular/core';
import { FormRequest } from './form-request';

@Component({
  templateUrl: './form-controls.html'  
})
export class FormControlsComponent { 

    constructor() {
      
      this.Request = new FormRequest();

      var items = [
        { Name: "Minutes", Code: "M" },
        { Name: "Hours", Code: "H" },
        { Name: "Days", Code: "D" },
      ];

      var items = [
        { Name: "Minutes", Code: "M" },
        { Name: "Hours", Code: "H" },
        { Name: "Days", Code: "D" },
        { Name: "2Days", Code: "D" },
        { Name: "3Days", Code: "D" },
        { Name: "4Days in the week", Code: "D" },
        { Name: "5 DaDays in the weekys", Code: "D" },
        { Name: "6 Days in the week", Code: "D" },
        { Name: "7  Days in the week Days", Code: "D" },
        { Name: "8 Days in the weekDays", Code: "D" },
      ];

      this.Request.Properties["CheckBoxComboBox"].Items = items.slice();
      this.Request.Properties["CheckBoxComboBox"].ItemsSource = items.slice();
      this.Request.Properties["ComboBox"].ItemsSource = items.slice();
      this.Request.Properties["ComboBox"].Item = items[0];
    }
  
    onClear() {
      this.Request.ClearProperties();
    }
    onSubmit(event) {

    }
    onCancel(event) {

    }
    
    public Request: FormRequest;    
    public SelectedItem;
    IsBusy: boolean;


}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/form-controls/form-controls-component.ts